import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import * as authActions from 'global/actions/authActions';
import { useActions } from 'hooks/useActions';
import { Input } from 'user/components';
import { TextLink } from './styles';
import { Header, Body, Footer, FooterButton } from 'components/Modals/modalElements';

// Get fragment with modal sign in functionality
export default function ModalContentSignIn({ email, setEmail, onCancel, goToSignUp, goToResetPassword }) {
  const { authLoading } = useSelector((state) => state.auth);
  const { login } = useActions(authActions);

  const [password, setPassword] = useState('');

  const onEnterSignIn = (e) => e.key === 'Enter' && email && password && !authLoading && login(email, password, true);

  return (
    <>
      <Header>Log in</Header>
      <Body loading={authLoading}>
        <Input
          type="text"
          autoFocus={!email}
          value={email}
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={onEnterSignIn}
        />
        <Input
          type="password"
          autoFocus={email && !password}
          value={password}
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={onEnterSignIn}
        />
        <TextLink onClick={goToResetPassword}>Forgot Password</TextLink>
        <i title="Your current code will be replaced if your account have made a solution previously">
          Note: Your current code might be replaced
        </i>
      </Body>
      <Footer>
        <FooterButton onClick={onCancel} label="Cancel" />
        <FooterButton onClick={goToSignUp} label="Sign Up" />
        <FooterButton
          onClick={() => login(email, password, true)}
          label="Log in"
          autoFocus={email && password}
          disabled={authLoading || !email || !password}
        />
      </Footer>
    </>
  );
}
